$(document).ready(function(){   
   
  function updateHeading() {
    const heading = $('.home-hone-tag h1');
    const originalText = heading.data('original-text') || heading.text(); // Get original text or store it
    const searchString = 'de produits sanitaire '; // String to remove
    const maxWidth = 768; // Define mobile view max width

    if (window.innerWidth <= maxWidth) {
      // Only modify if the string is present and the text has not been changed before
      if (originalText.includes(searchString)) {
        const newText = originalText.replace(searchString, '');
        heading.text(newText);
        heading.data('original-text', originalText); // Store original text in a data attribute
      }
    } else {
      // Revert to original text if not in mobile view
      if (heading.data('original-text')) {
        heading.text(heading.data('original-text'));
      }
    }
  }

  // Run on initial load
  updateHeading();

  // Bind the function to the window resize event
  $(window).resize(updateHeading);

  
  $("#ez-toc-container a.ez-toc-pull-right").attr("href","javascript:void(0);");
  $(".read-more-btns a.dsm-readmore-btn").attr("href","javascript:void(0);");


  $('#kaktusc-cart-icon,#kaktusc-app').click(function(){
    $(this).toggleClass("active");  
    $('body').toggleClass("active");  
  });
  
  $("#ez-toc-container span.ez-toc-icon-toggle-span").click(function(){    
      $("#ez-toc-container ul.ez-toc-list").addClass("active");
    $("#ez-toc-container ul.ez-toc-list").slideToggle("slow");
  });

   $(".read-more-btns a.dsm-readmore-btn").click(function(){
       $(this).hide();
       $(".read-more-btns a.dsm-readmore-btn.rm-hide").show();
      $(".read-more-content p.show-hide").removeClass("show-hide").addClass('show-more');
      $(".read-more-content").find('p:gt(0)').addClass('show-more-first');
  });
  $(".read-more-btns a.dsm-readmore-btn.first-btn").click(function(){
    console.log('clicked');
      $(this).hide();
      $(".read-more-btns a.dsm-readmore-btn.rm-hide").show();
      $(".read-more-content p.show-hide").removeClass("show-hide").addClass('show-more');
      $(".read-more-content").find('p:gt(0)').addClass('show-more-first');
  });
  $(".read-more-btns a.dsm-readmore-btn.rm-hide").click(function(){
       $(this).hide();
      $(".read-more-btns a.dsm-readmore-btn.first-btn").show();
      $(".read-more-content").find('p:gt(0)').removeClass("show-more-first").addClass('show-hide');
  });

   $("body.product.lot-de-5-essuie-fesses-reutilisable-page .sticky_addtocart,body.product.lot-de-5-essuie-fesses-reutilisable-page .prod-add-btn").click(function(){
     var scrollDIV = $('product-info');    
    $("html, body").animate({ scrollTop: $(scrollDIV).offset().top }, 1000);
  });

  $("body.product.le-bidet-portable-page.gradient #sticky_addtocart").click(function(){
     var scrollDIV = $('product-info');    
    $("html, body").animate({ scrollTop: $(scrollDIV).offset().top }, 1000);
  });
  
  $("#sticky_addtocart,.sticky_addtocart,.prod-add-btn").click(function(){
    //$(".product-form__buttons button.product-form__submit").trigger("click");
    var scrollDIV = $('variant-selects');    
    $("html, body").animate({ scrollTop: $(scrollDIV).offset().top - 300 }, 1000);
  });

  
  
  
 
    
  $('.product-variants .variant input[type="radio"]').change(function() {  
    var selectedValue = $(this).data('pname');
    var selectedVariantId = $(this).val();
    $("product-form .form input[name='id']").val(selectedVariantId);    
    /*$('variant-selects .select .select__select').find('option').prop('selected', false); 
    $('variant-selects .select .select__select').find('option').removeAttr('selected'); */
    console.log(selectedValue);
    console.log($('variant-selects .select .select__select').val());
     $('variant-selects .select .select__select').val(selectedValue);
     /*$('variant-selects .select .select__select option').each(function() {      
       if ($(this).val() === selectedValue) {   
         console.log(selectedValue+" and "+$(this).val());          
          $(this).prop('selected', true);  
         $(this).attr('selected', 'selected');
       }
     });*/
    
    //$('variant-selects .select .select__select').trigger("change");
    $('product-info .product-form__buttons .product-form__submit').click();
    $(".modal-content span.close").trigger('click');
  });   

  $(".trustreview-btn").click(function(){
    var scrollDIV = $(this).data('divid');    
    $("html, body").animate({ scrollTop: $(scrollDIV).offset().top - 300 }, 1000);
  });

  $("#goto-prod-sec").click(function(){    
    $("html, body").animate({ scrollTop: $('.product').offset().top }, 1000);
  });
 

  $("#offer-sec").click(function(){    
    $("html, body").animate({ scrollTop: $('#offer-section').offset().top }, 1000);
  });

   $(".product_multicolumn_sec").click(function(){    
    $("html, body").animate({ scrollTop: $('#product_multicolumn').offset().top }, 1000);
  });

  

  

  
  $(".text_first.show-less #show-mre").click(function(){
    $(this).parents('.image-with-text__text.rte.body').find('p').slideDown('slow');
    $(this).hide();
    $(".text_first.show-less #show-les").show();
  });
  
  $(".text_first.show-less #show-les").click(function(){
    $(this).parents('.image-with-text__text.rte.body').find('p').slideDown('slow');
    $(this).parents('.image-with-text__text.rte.body').find('p:gt(0)').hide();    
    $(this).hide();
    $(".text_first.show-less #show-mre").show();
  });

  $(".image_first.show-less #show-mre").click(function(){
    $(this).parents('.image-with-text__text.rte.body').find('p').slideDown('slow');
    $(this).hide();
    $(".image_first.show-less #show-les").show();
  });
  
  $(".image_first.show-less #show-les").click(function(){
    $(this).parents('.image-with-text__text.rte.body').find('p').slideDown('slow');
    $(this).parents('.image-with-text__text.rte.body').find('p:gt(0)').hide();    
    $(this).hide();
    $(".image_first.show-less #show-mre").show();
  });
  
  $(".show-less-cont #show-cmre").click(function(){
    $(this).parents('.image_content_overlay_content').find('p').slideDown('slow');
    $(this).hide();
    $(".show-less-cont #show-cles").show();
  });
  
  $(".show-less-cont #show-cles").click(function(){
    $(this).parents('.image_content_overlay_content').find('p').slideDown('slow');
    $(this).parents('.image_content_overlay_content').find('p:gt(0)').hide();    
    $(this).hide();
    $(".show-less-cont #show-cmre").show();
  });


  $(".show-less-quotecont #show-mre").click(function(){
    $(this).parents('.grid_block_content').find('p').slideDown('slow');
    $(this).hide();
    $(".show-less-quotecont #show-les").show();
  });
  
  $(".show-less-quotecont #show-les").click(function(){
    $(this).parents('.grid_block_content').find('p').slideDown('slow');
    $(this).parents('.grid_block_content').find('p:gt(0)').hide();    
    $(this).hide();
    $(".show-less-quotecont #show-mre").show();
  });
  
  $("#accord-open").click(function(){
    $(".calc-ac-content").slideDown('slow');
    $(this).hide();
    $("#accord-cls").show();
  });
  
  $("#accord-cls").click(function(){
    $(".calc-ac-content").slideUp('slow');
    $(this).hide();
    $("#accord-open").show();
  });

  $('.jeux-accorion .jeux_toggle_title').click(function(){    
    var isActiveJeux = $(this).hasClass('active');
    $('.jeux-accorion').removeClass('active').find('.jeux_toggle_content').slideUp();
    if (!isActiveJeux) {
      $(this).addClass('active').siblings('.jeux_toggle_content').slideDown();
    }
  });

  $(".short_pvideo_image").click(function(){
    var VideoUrl = $(this).find(".short_img_sec").data("video_url");    
    $(".popup_video_container").addClass("enabled");
      $("body").addClass("video-enabled");
      $(".popup_video_play video").attr('src', VideoUrl);
      $(".popup_video_play video")[0].load();
        // Play the video after the source is set
        $(".popup_video_play video")[0].play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
  });
  
  $(".short_video_image").click(function(){
    var VideoUrl = $(this).find(".short_img_sec").data("video_url");    
    $(".popup_video_container").addClass("enabled");
      $("body").addClass("video-enabled");
      $(".popup_video_play video").attr('src', VideoUrl);
      $(".popup_video_play video")[0].load();
        // Play the video after the source is set
        $(".popup_video_play video")[0].play().catch(function(error) {
          console.error('Error attempting to play video:', error);
        });
  });
  
  $(".popup_video_container,.popup_video_play .close_icon").click(function(){
    $("body").removeClass("video-enabled");
    $(".popup_video_container").removeClass("enabled");
    $(".popup_video_play video").attr('src', '');
  });
  

  $('.faq-item-accordion').click(function() {    
    var isActive = $(this).hasClass('active');
    $('.faq-item-accordion').removeClass('active').find('.content').slideUp();
    if (!isActive) {
      $(this).addClass('active').find('.content').slideDown();
    }
  });

  $("#goto-prod-btn").click(function(){
    $('html, body').animate({
      scrollTop: $('.product-template-doc').offset().top
    }, 1000);
  });

  $('#review_grid_more').on('click', function() {    
    $('.grid_review_list div.grid_review_item.hidden').slice(0, 3).removeClass('hidden');
    var NlistItems = $('.grid_review_list div.grid_review_item.hidden').length;    
    if(NlistItems <= 0){
      $(this).hide();
    }
  });

  $(".product__description .accordion__title").click(function(){
    $(this).toggleClass("active");
    $(this).siblings(".desc").slideToggle();
  });

  
  /*$('.faq_head').click(function(){          
    $('.faq_content').slideUp('slow');
    $('.faq_head').removeClass('active');
    $('.faq_item').removeClass("active");
    $(this).parents('.faq_item').addClass("active");
    $(this).toggleClass('active');
    $(this).siblings('.faq_content').slideDown('slow');
  });*/

  $('.faq_item').click(function() {    
    var isActive = $(this).hasClass('active');
    $('.faq_item').removeClass('active').find('.faq_content').slideUp();
    if (!isActive) {
      $(this).addClass('active').find('.faq_content').slideDown();
    }
  });

  $('.rmore-btn').click(function() {    
    $(this).hide();
    $('.lmore-btn').show();
    $(this).parents(".svg_conts").find('.section_more').slideDown();    
  });
  $('.lmore-btn').click(function() {    
    $(this).hide();
    $('.rmore-btn').show();
    $(this).parents(".svg_conts").find('.section_more').slideUp();    
  });

  $(".grid_review_slider #read-more").click(function(){
    $(this).parents(".greview-content").find(".review-cont .revcon-full").slideDown();
    $(this).parents(".greview-content").find(".review-cont .revcon-exp").slideUp("fast");
    $(this).hide();
    $(this).parents(".greview-content").find(".reivew-actions #read-less").show();
  });
  $(".grid_review_slider #read-less").click(function(){
    $(this).parents(".greview-content").find(".review-cont .revcon-exp").slideDown();
    $(this).parents(".greview-content").find(".review-cont .revcon-full").slideUp("fast");
    $(this).hide();
    $(this).parents(".greview-content").find(".reivew-actions #read-more").show();
  });

  $(".grid_review_list #read-more").click(function(){
    $(this).parents(".greview-content").find(".review-cont .revcon-full").slideDown();
    $(this).parents(".greview-content").find(".review-cont .revcon-exp").slideUp("fast");
    $(this).hide();
    $(this).parents(".greview-content").find(".reivew-actions #read-less").show();
  });
  $(".grid_review_list #read-less").click(function(){
    $(this).parents(".greview-content").find(".review-cont .revcon-exp").slideDown();
    $(this).parents(".greview-content").find(".review-cont .revcon-full").slideUp("fast");
    $(this).hide();
    $(this).parents(".greview-content").find(".reivew-actions #read-more").show();
  });
  
  $('.brandlogoSlider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
 
  $('.brandlogocaro').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]
  });
  
  $('.grid_review_slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.blog_sldier').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.grid_review_list-').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.blog-article-slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
  });  

  $('.upsell_listing1').slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
  });  




  
  $('.price_calc_slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  
    
  $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.slider-nav',
      responsive: [
        {
            breakpoint: 992,
            settings: {
              dots: true,
            }
        }
      ]
  });
  $('.slider-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical:true,
      asNavFor: '.slider-for',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
            breakpoint: 992,
            settings: {
             vertical:true,
              slidesToShow: 4,
              slidesToScroll: 1
            }
        },
        {
          breakpoint: 768,
          settings: {
            vertical:true,
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            slidesToShow: 2,
          }
        }
      ]
  });
  $('.slider-for').slickLightbox({
    src: 'src',
    itemSelector: '.slider-banner-image img',
    background: 'rgba(0, 0, 0, .7)'
  });


  $('.slider-for-merlin').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true, 
      infinite: true,
      fade: true,
      speed: 1000,
      asNavFor: '.slider-nav-merlin',
      responsive: [
        {
            breakpoint: 992,
            settings: {
              dots: true,
            }
        }
      ]
  });
  $('.slider-nav-merlin').slick({
      slidesToShow: 6,
      slidesToScroll: 1,   
      infinite: true,
      vertical:true,    
      asNavFor: '.slider-for-merlin',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
            breakpoint: 992,
            settings: {
             vertical:true,
              slidesToShow: 4,
              slidesToScroll: 1
            }
        },
        {
          breakpoint: 768,
          settings: {
            vertical:true,
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            slidesToShow: 2,
          }
        }
      ]
  });
  $('.slider-for-merlin').slickLightbox({
    src: 'src',
    itemSelector: '.slider-banner-image img',
    background: 'rgba(0, 0, 0, .7)'
  });
  
});